
import { IeLynxUser } from "../../common/models/eLynxUser";
import restService from "../rest-service/RestService";
import { IAssignUserFavoriteModel, IAssignUserFavoriteParams, IUIDefaultViewModel, IUIUserFavoriteModel, IUIUserFavoriteValidationResult } from "./Models";

const UIPersonalizationDataService = {

    validateUserFavorite: async function (favoriteID: number, signal?: AbortSignal): Promise<IUIUserFavoriteValidationResult> {
        const response = await restService.get<IUIUserFavoriteValidationResult>(`/userfavorites/${favoriteID}/validate`, signal);
        return response.data;
    },
    deleteUserFavorite: async function (favoriteID: number, signal?: AbortSignal): Promise<void> {
        await restService.delete(`userfavorites/${favoriteID}`, signal);
    },
    getUserFavorites: async function (signal?: AbortSignal): Promise<Array<IUIUserFavoriteModel>> {
        const response = await restService.get<Array<IUIUserFavoriteModel>>("userfavorites", signal);
        return response.data;
    },
    saveUserFavorite: async function (favorite: IUIUserFavoriteModel, signal?: AbortSignal): Promise<IUIUserFavoriteModel> {
        const response = await restService.post<IUIUserFavoriteModel, IUIUserFavoriteModel>("userfavorites", favorite, signal);
        return response.data;
    },
    // getUserFavorite: async function (favoriteID: number, signal?: AbortSignal): Promise<IUIUserFavoriteModel> {
    //     const path: string = `userfavorites/${favoriteID}`;
    //     const response = await restService.get<IUIUserFavoriteModel>(path, signal);
    //     return response.data;
    // },
    manageUserFavorites: async function (userFavorites: Array<IUIUserFavoriteModel>): Promise<void> {
        const path: string = "userfavorites/manage";
        await restService.post<Array<IUIUserFavoriteModel>, void>(path, userFavorites);
    },
    getUserDefaultViews: async function (signal?: AbortSignal): Promise<IUIDefaultViewModel[]> {
        const response = await restService.get<IUIDefaultViewModel[]>("defaultviews", signal);
        return response.data;
    },
    saveUserDefaultView: async function (model: IUIDefaultViewModel): Promise<IUIDefaultViewModel> {
        const response = await restService.post<IUIDefaultViewModel, IUIDefaultViewModel>("defaultview", model);
        return response.data;
    },
    deleteUserDefaultView: async function (id: number, signal?: AbortSignal): Promise<void> {
        await restService.delete(`defaultview/${id}`, signal);
    },
    getUserFavoriteAccessibleUsers: async function (groupID: number, favoriteID: number, signal?: AbortSignal): Promise<IeLynxUser[]> {
        const response = await restService.get<IeLynxUser[]>(`groups/${groupID}/userfavorites/${favoriteID}/accessibleusers`, signal);
        return response.data;
    },
    assigntUserFavorite: async function (groupID: number, data: IAssignUserFavoriteParams): Promise<void> {
        await restService.post<IAssignUserFavoriteModel[], void>(`groups/${groupID}/userfavorites/${data.favoriteID}/assign`, data.assignments);
    },

};

export default UIPersonalizationDataService;


//     public getDefaultViews(): Services.RestPromise<Array<Models.IUIDefaultViewModel>> {

//         const path: string = "defaultviews";

//         return this._restService
//             .get<Array<Models.IUIDefaultViewModel>>(path)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

//     public getUserFavorite(favoriteID: number): Services.RestPromise<Models.IUIUserFavoriteModel> {

//         const path: string = [
//             "userfavorites",
//             favoriteID
//         ].join("/");

//         return this._restService
//             .get<Models.IUIUserFavoriteModel>(path)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

//     public getUserHomeFavorite(): Services.RestPromise<Models.IUIUserFavoriteModel> {

//         const path: string = [
//             "userfavorites",
//             "home"
//         ].join("/");

//         return this._restService
//             .get<Models.IUIUserFavoriteModel>(path)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

//     public getUserStartGroup(): Services.RestPromise<Models.IeLynxGroupModel> {

//         const path: string = "userstartgroup";

//         return this._restService
//             .get<Models.IeLynxGroupModel>(path)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

//     public getUserStartGroupId(): Services.RestPromise<number> {

//         const path: string = "userstartgroupid";

//         return this._restService
//             .get<number>(path)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

//     public manageUserFavorites(userFavorites: Array<Models.IUIUserFavoriteModel>): Services.RestPromise<any> {

//         const path: string = [
//             "userfavorites",
//             "manage"
//         ].join("/");

//         return this._restService
//             .post<Models.IUIUserFavoriteModel>(path, userFavorites)
//             .then((data) => {

//                 return data.entity;

//             });

//     }

